import { TableData } from '../components/staticTable/staticTable.component';
import { FavouriteTag } from '../hooks/filters/interfaces/favourite-value.interface';
import { FaqGridItemsComponentProps } from '../routes/about/components/faq-accordion-grid.component';
import { FaqItemComponentProps } from '../routes/about/components/faq-accordion.component';
import { FeedbackSlideCardComponentProps } from '../routes/about/components/feedback-slide-card.component';
import { HomeSlideCardComponentProps } from '../routes/home/components/home-slide-card.component';
import { ReleaseNotesProps } from '../routes/irishelpcenter/components/releasenotes.component';
import { ReleaseNotesModelProps } from '../routes/releases/components/release-versions/irisLaunch.component';
import { ABOUT_IMAGES_REPO } from './about-image-repo';
import { IMAGES_REPO } from './home-image-repo';

export const PATH_TAGS: Record<string, FavouriteTag[]> = {
  '/t/r': [
    {
      title: 'Demand model',
      src: IMAGES_REPO.HomeCardDemand,
      description:
        'Utilize the Demand Model to forecast future sales trends based on historical data and market analysis. This dashboard helps you identify patterns, predict customer demand, and make informed decisions to optimize your inventory and sales strategies.',
      href: '/t/r',
    },
  ],
  '/t/r/d': [
    {
      title: 'Decomp model',
      src: IMAGES_REPO.HomeCardDecomp,
      description:
        'Access the Decomp Insights dashboard for a detailed breakdown of sales performance. This tool provides comprehensive insights into various factors influencing sales, helping you understand the contributions of different elements and improve your sales tactics.',
      href: '/t/r/d',
    },
  ],
  '/t/i': [
    {
      title: 'Decomp Insights',
      src: IMAGES_REPO.HomeCardDecompInsights,
      description:
        'Launching Soon! The Scenario Planner will enable you to simulate different sales scenarios and their potential impacts on your business. Plan for various market conditions and develop strategies to maximize your sales potential.',
      href: '/t/i',
    },
  ],
  '/t/n': [
    {
      title: 'Netflow',
      src: IMAGES_REPO.Netflow,
      description: 'Netflow',
      href: '/t/n',
    },
  ],
  '/t/s': [
    {
      title: 'Price & Promo Simulator',
      src: IMAGES_REPO.ScenarioPlanner,
      description:
        'The Scenario Planner enables you to simulate different sales scenarios and their potential impacts on your business. Plan for various market conditions and develop strategies to maximize your sales potential.',
      href: '/t/s',
    },
  ],
};

export const capabilitiesSlideCardsInfo: HomeSlideCardComponentProps[] = [
  {
    title: 'All Outlet Central',
    description:
      'Provides a comprehensive overview of sales performance across all channels (Includes Costco and Amazon). It includes dollars and Eq sales data only.',
    href: 'https://app.powerbi.com/groups/e1df06f7-9c37-4ecc-ada0-f3416c700cf4/reports/9dcd6676-f030-4714-b54b-727b0e599727/ReportSection5b0431efeba152d7dee5?ctid=fee2180b-69b6-4afe-9f14-ccd70bd4c737&experience=power-bi',
    src: IMAGES_REPO.DCPImage,
    tags: [
      {
        title: 'Power BI',
        description: 'All Outlet Central',
        href: 'https://app.powerbi.com/groups/e1df06f7-9c37-4ecc-ada0-f3416c700cf4/reports/9dcd6676-f030-4714-b54b-727b0e599727/ReportSection5b0431efeba152d7dee5?ctid=fee2180b-69b6-4afe-9f14-ccd70bd4c737&experience=power-bi',
      },
    ],
  },
  {
    title: 'Commercial Analytics Hub',
    description: 'All the dashboards across KCNA Commercial Analytics!',
    href: 'http://www.commanalytics.kcc.com/',
    src: IMAGES_REPO.DCPAnalatics,
    tags: [
      {
        title: 'Website',
        description: 'TPM Model',
        href: 'http://www.commanalytics.kcc.com/',
      },
    ],
  },
  {
    title: 'Consumption Navigator',
    description:
      'The Consumption Analytics Navigator simplifies data visualization and offers guided analytics leveraging the analytics framework to empower users.',
    href: 'https://app.powerbi.com/groups/e1df06f7-9c37-4ecc-ada0-f3416c700cf4/reports/370b2bd2-aa42-4877-94dc-955d6a25ec2a?ctid=fee2180b-69b6-4afe-9f14-ccd70bd4c737&pbi_source=linkShare',
    src: IMAGES_REPO.DCPConsumption,
    tags: [
      {
        title: 'Power BI',
        description: 'TPM Model',
        href: 'https://app.powerbi.com/groups/e1df06f7-9c37-4ecc-ada0-f3416c700cf4/reports/370b2bd2-aa42-4877-94dc-955d6a25ec2a?ctid=fee2180b-69b6-4afe-9f14-ccd70bd4c737&pbi_source=linkShare',
      },
    ],
  },
  // {
  //   title: "Item 3",
  //   description: "Item 3 description",
  //   href: "#",
  //   src: IMAGES_REPO.img03,
  //   tags: [{ title: "IRIS", description: "Report Name", href: "#" }, { title: "PBI", description: "Report Name 2", href: "#" }]
  // }
];

export const feedbackSlideCardsInfo: FeedbackSlideCardComponentProps[] = [
  {
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.',
    user: {
      name: 'Example Name',
      role: 'Role Name',
      avatar: ABOUT_IMAGES_REPO.avatar01,
    },
  },
  {
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.',
    user: {
      name: 'Example Name',
      role: 'Role Name',
      avatar: ABOUT_IMAGES_REPO.avatar01,
    },
  },
  {
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.',
    user: {
      name: 'Example Name',
      role: 'Role Name',
      avatar: ABOUT_IMAGES_REPO.avatar01,
    },
  },
  {
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.',
    user: {
      name: 'Example Name',
      role: 'Role Name',
      avatar: ABOUT_IMAGES_REPO.avatar01,
    },
  },
  {
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.',
    user: {
      name: 'Example Name',
      role: 'Role Name',
      avatar: ABOUT_IMAGES_REPO.avatar01,
    },
  },
  {
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.',
    user: {
      name: 'Example Name',
      role: 'Role Name',
      avatar: ABOUT_IMAGES_REPO.avatar01,
    },
  },
  {
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.',
    user: {
      name: 'Example Name',
      role: 'Role Name',
      avatar: ABOUT_IMAGES_REPO.avatar01,
    },
  },
  {
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.',
    user: {
      name: 'Example Name',
      role: 'Role Name',
      avatar: ABOUT_IMAGES_REPO.avatar01,
    },
  },
  {
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.',
    user: {
      name: 'Example Name',
      role: 'Role Name',
      avatar: ABOUT_IMAGES_REPO.avatar01,
    },
  },
];

export const faqItemsInfo: FaqItemComponentProps[] = [
  {
    icon: IMAGES_REPO.DataFlowOne,
    title: 'What feeds IRIS?',
    description:
      'The KCNA Common Data Model feeds IRIS UPC level Nielsen data, Amazon Edge, Costco, and Kroger 84.51 every week.',
    eventKey: '0',
  },
  {
    icon: IMAGES_REPO.Octagon,
    title: 'What are current capability gaps?',
    description:
      'If we don’t have data for it, we can’t control for it. Our models are only as good as the data we can get our hands on and what is available to KCNA. For example, questions around shelf placement, planogram, and store-level detail are out of scope for the time being.',
    eventKey: '1',
  },
  {
    icon: IMAGES_REPO.Container,
    title: 'How often is IRIS updates?',
    description:
      'Models updated by the first Monday of every month and re-scored every Monday in between modeling windows.',
    eventKey: '2',
  },
  {
    icon: IMAGES_REPO.DataFlowTwo,
    title: 'What level of granularity can you get down to? ',
    description: 'Weekly + SKU + Total Corp in Nielsen for now.',
    eventKey: '3',
  },
  {
    icon: IMAGES_REPO.DataFaq,
    title: 'Can you see drivers for competition as well?',
    description:
      'For all markets except Costco, we can provide competitor details and control for competitive activity in our models.',
    eventKey: '4',
  },
  {
    icon: IMAGES_REPO.Eye,
    title: 'Will there be visibility to Costco and Amazon?',
    description: 'Yes! Coming later in 2024',
    eventKey: '5',
  },
];

export const releaseNotes: ReleaseNotesProps[] = [
  {
    id: 'q22025',
    title: 'Q2 2025 Release Notes',
    description:
      "Welcome to your Quarterly dose of IRIS updates! Dive in for exclusive insights, updates, and resources tailored just for you. Let's keep it engaging, informative, and, most importantly, beneficial for you.",
    image: IMAGES_REPO.ReleaseNotes,
    tag1: 'Q2 2025',
    tag2: '8 min',
  },
  {
    id: 'q12025',
    title: 'Q1 2025 Release Notes',
    description:
      "Welcome to your Quarterly dose of IRIS updates! Dive in for exclusive insights, updates, and resources tailored just for you. Let's keep it engaging, informative, and, most importantly, beneficial for you.",
    image: IMAGES_REPO.ReleaseNotes,
    tag1: 'Q1 2025',
    tag2: '8 min',
  },
  {
    id: 'q42024',
    title: 'Q4 2024 Release Notes',
    description:
      "Welcome to your Quarterly dose of IRIS updates! Dive in for exclusive insights, updates, and resources tailored just for you. Let's keep it engaging, informative, and, most importantly, beneficial for you.",
    image: IMAGES_REPO.ReleaseNotes,
    tag1: 'Q4 2024',
    tag2: '8 min',
  },
  {
    id: 'decompInsights',
    title: 'Decomp Insights',
    description:
      "IRIS's decomp insights provide a detailed breakdown of the drivers of your business performance, including the impact of different pricing and promotional strategies, helping you optimize your business decisions.",
    image: IMAGES_REPO.ReleaseNotes,
    tag1: 'Decomp Model',
    tag2: '8 min',
  },
  {
    id: 'demandModel',
    title: 'Demand Model',
    description:
      'IRIS\'s demand model provides insights into the drivers of demand for your products, including base price, promo price, distribution, feature, and display, helping you understand the "why" behind your business performance.',
    image: IMAGES_REPO.ReleaseNotes,
    tag1: 'Demand Model',
    tag2: '8 min',
  },
  {
    id: 'irisLaunch',
    title: 'IRIS Launch',
    description:
      'IRIS is a KC proprietary ecosystem of machine learning models and visualizations that analyze the drivers of consumer demand, so KC can optimize our business​.',
    image: IMAGES_REPO.ReleaseNotes,
    tag1: 'Demand Model',
    tag2: '8 min',
  },
];

export const releaseNotesModels: ReleaseNotesModelProps[] = [
  {
    id: 'decompInsights',
    title: 'Decomp Insights',
    description:
      'Decomp Insights unlocks deeper insights into why sales volume is changing and quantifies the impact of distribution, price and promotional drivers on total volume when comparing two timeframes.',
    image: IMAGES_REPO.DecompIrisLaunchImage,
    button: 'Learn More',
    path: '/releases/decompInsights',
  },
  {
    id: 'demandModel',
    title: 'Demand Model',
    description: 'Forecast future sales trends using historical data.',
    image: IMAGES_REPO.DemandIrisLaunchImage,
    button: 'Learn More',
    path: '/releases/demandModel',
  },
  {
    id: 'proactiveAlert',
    title: 'Proactive Alerting',
    description:
      'Proactive alerting helps you monitor market changes by selecting KPIs and competitors you care about and alerts you anytime there are changes above the threshold you set.',
    image: IMAGES_REPO.ProactiveIrisLaunchImage,
    button: 'Learn More',
    path: '/releases/proactiveAlert',
  },
];

export const faqGridItemsInfo: FaqGridItemsComponentProps[] = [
  {
    icon: IMAGES_REPO.DataFlowOne,
    title: 'When would RGM use Decomp Insights?',
    descriptions: [
      'How did our price increase perform in market?',
      'Who are we losing promo dollars to? Where are we winning promo drivers',
      'What are key brands at a retailer? Who has been driving sales volume?',
      'What’s happening in this brand? Is price actually driving volume change?',
      'Which brands are most impacted by seasonality?',
      'Which retailers are we winning and losing at?',
    ],
    eventKey: '0',
  },
  {
    icon: IMAGES_REPO.Octagon,
    title: 'When would Customer Development use Decomp Insights?',
    descriptions: [
      'What is driving share gain from other brands?',
      'Which pack sizes have seen distribution changes?',
      'Annual category planning: What drivers are most relevant for brands at a specific customer?',
      'Are variances to forecast shipments driven by POS or forecast?',
      'Which changes are happening in top line sales?',
      'How is a new item performing?',
    ],
    eventKey: '1',
  },
  {
    icon: IMAGES_REPO.Container,
    title: 'When would I use Decomp Insights?',
    descriptions: [
      'What is driving share gain for other brands?',
      'How did our price increase perform in market?',
      'Who are we losing promo dollars to? Where are we winning promo dollars?',
      'What are the key brands at a retailer? Who has been driving sales volume?',
      'Which retailers are we winning/losing at?',
      'How is a new item performing?',
    ],
    eventKey: '2',
  },
];

export const dataForBaseDrivers: TableData = {
  headers: [
    { key: 'driver', displayName: 'Driver' },
    { key: 'metric', displayName: 'Metric' },
  ],
  rows: [
    { driver: 'Distribution', metric: 'Adjusted % ACV' },
    { driver: 'Base Price', metric: 'IRIS calculated average base price' },
    {
      driver: 'Competitive Base Price',
      metric:
        'IRIS calculated average base price for other packs in the category',
    },
    {
      driver: 'Competitive Distribution',
      metric: 'Adjusted % ACV for other packs in the category',
    },
    { driver: 'Seasonality', metric: 'Captures Holiday/WoM/Seasonal Demand' },
  ],
};

export const dataForPromoDrivers: TableData = {
  headers: [
    { key: 'driver', displayName: 'Driver' },
    { key: 'metric', displayName: 'Metric' },
  ],
  rows: [
    {
      driver: 'Promo Price',
      metric: '% Discount off IRIS calculated base price',
    },
    {
      driver: 'Competitive Promo Price',
      metric:
        '% Discount off IRIS calculated base price of other packs in the category',
    },
    { driver: 'Feature', metric: '% ACV any feature' },
    { driver: 'Display', metric: '% ACV any display' },
  ],
};

export const dataForPredictionVarianceDriverss: TableData = {
  headers: [
    { key: 'driver', displayName: 'Driver' },
    { key: 'metric', displayName: 'Metric' },
  ],
  rows: [
    {
      driver: 'Promo Price',
      metric: '% Discount off IRIS calculated base price',
    },
    {
      driver: 'Competitive Promo Price',
      metric:
        '% Discount off IRIS calculated base price of other packs in the category',
    },
  ],
};

export interface VideoDataProps extends HomeSlideCardComponentProps {
  group: string;
  date: string;
}

export const videoData: VideoDataProps[] = [
  {
    title: 'Decomp Insights Interpretation',
    group: 'Decomp Insights',
    date: '2024-10-22',
    description:
      'Learn how to use Decomp Insights to boost your analytics and understand the breakdown of your business performance.',
    src: IMAGES_REPO.DecompInsightsInterpretation,
    linkSrc:
      'https://kimberlyclark.sharepoint.com/sites/X1234/_layouts/15/embed.aspx?UniqueId=b056a5cd-4da0-4358-98ad-495fd888bf7b&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create',
    href: '#',
  },
  {
    title: 'Decomp Insights Navigation',
    group: 'Decomp Insights',
    date: '2024-10-22',
    description:
      'Learn how to use Decomp Insights to boost your analytics and understand the breakdown of your business performance.',
    src: IMAGES_REPO.DecompInsightsNavigation,
    linkSrc:
      'https://kimberlyclark.sharepoint.com/sites/X1234/_layouts/15/embed.aspx?UniqueId=20f8787b-d615-4594-a232-5eb247bb9f3b&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create',
    href: '#',
  },
  {
    title: 'Demand Model Navigation',
    group: 'Demand Model',
    date: '2024-10-22',
    description:
      'Insights into the Demand Model, including sales projections, customer demand forecasting, and how it impacts business strategies.',
    src: IMAGES_REPO.DemandModelNavigation,
    linkSrc:
      'https://kimberlyclark.sharepoint.com/sites/X1234/_layouts/15/embed.aspx?UniqueId=398301ea-7bcd-4239-b9ac-12fbd7d6667c&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create',
    href: '#',
  },
  {
    title: 'IRIS Drivers',
    group: 'IRIS',
    date: '2024-10-22',
    description:
      'IRIS combines insights from both the Decomp Insights and Demand Model to offer a comprehensive view of your business performance.',
    src: IMAGES_REPO.IRISDrivers,
    linkSrc:
      'https://kimberlyclark.sharepoint.com/sites/X1234/_layouts/15/embed.aspx?UniqueId=ce80c129-9135-457c-8bd1-fe7c830c589a&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create',
    href: '#',
  },
  {
    title: 'IRIS Navigation',
    group: 'IRIS',
    date: '2024-10-22',
    description:
      'IRIS combines insights from both the Decomp Insights and Demand Model to offer a comprehensive view of your business performance.',
    src: IMAGES_REPO.IRISNavigation,
    linkSrc:
      'https://kimberlyclark.sharepoint.com/sites/X1234/_layouts/15/embed.aspx?UniqueId=73044b79-1f36-436d-8ca0-64e07d29a1ff&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create',
    href: '#',
  },
  {
    title: 'IRIS Teaser',
    group: 'IRIS',
    date: '2024-10-22',
    description:
      'IRIS combines insights from both the Decomp Insights and Demand Model to offer a comprehensive view of your business performance.',
    src: IMAGES_REPO.IRISTeaser,
    linkSrc:
      'https://kimberlyclark.sharepoint.com/sites/X1234/_layouts/15/embed.aspx?UniqueId=5e265c5f-401c-41b8-8be4-2818b4fa708a&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create',
    href: '#',
  },
  {
    title: 'Proactive Alerting',
    group: 'Alerts',
    date: '2024-10-25',
    description: 'An advanced walkthrough of the Proactive Alerting.',
    src: IMAGES_REPO.ProactiveALerting,
    linkSrc:
      'https://kimberlyclark.sharepoint.com/sites/X1234/_layouts/15/embed.aspx?UniqueId=425c349c-5b03-4c71-9ab1-8bba2f8062cc&embed=%7B%22ust%22%3Atrue%2C%22hv%22%3A%22CopyEmbedCode%22%7D&referrer=StreamWebApp&referrerScenario=EmbedDialog.Create',
    href: '#',
  },
];

export interface MatrixHeader {
  key: string;
  displayName: string;
}

export interface MatrixRow {
  source: string;
  sourceId: string;
  [key: string]: string | number | null;
}

export interface MatrixData {
  headers: MatrixHeader[];
  rows: MatrixRow[];
}
// [main]
export const BRAND_COLORS: Record<string, string> = {
  'Angel Soft': 'rgba(66, 146, 152, 1)',
  Bounty: 'rgba(63, 125, 49, 1)',
  Brawny: 'rgba(215, 128, 133, 1)',
  'Cardinal Tissue': 'rgba(54, 162, 235, 1)',
  Charmin: 'rgba(76, 167, 225, 1)',
  Cottonelle: 'rgba(9, 32, 87, 1)',
  Dude: 'rgba(0, 71, 5, 1)',
  Fiora: 'rgba(255, 159, 64, 1)',
  Goodwipes: 'rgba(16, 41, 153, 1)',
  Kcp: 'rgba(218, 112, 214, 1)',
  Kleenex: 'rgba(85, 99, 164, 1)',
  'Marcal Brnd Grp': 'rgba(165, 42, 42, 1)',
  Md: 'rgba(128, 128, 128, 1)',
  Northern: 'rgba(131, 103, 103, 1)',
  Puffs: 'rgba(112, 163, 48, 1)',
  'Pvt Lbl': 'rgba(255, 144, 0, 1)',
  'Remaining Brnd': 'rgba(68, 88, 114, 1)',
  'Remaining G-p Brnd': 'rgba(142, 133, 155, 1)',
  'Remaining Irving Brnd': 'rgba(150, 92, 21, 1)',
  'Remaining K-c Brnd': 'rgba(143, 143, 188, 1)',
  'Remaining Krg Brnd': 'rgba(143, 188, 143, 1)',
  Scott: 'rgba(35, 86, 177, 1)',
  Scotties: 'rgba(253, 244, 120, 1)',
  'Seventh Generation': 'rgba(37, 91, 68, 1)',
  Sparkle: 'rgba(10, 33, 101, 1)',
  Viva: 'rgba(81, 62, 140, 1)',
  'White Cloud': 'rgba(75, 192, 192, 1)',
};

//barchart
export interface BarChartDataProps {
  label: string;
  data: (number | null)[];
  backgroundColor: string;
}

// valume dashboardData
export interface SummaryDataProps {
  label: string;
  value: string;
  boxValue: string;
}

//lazyloading
export interface NetFlowLazyLoadProps {
  header: string;
  Paragraph: string;
}

export const netflowlazy: NetFlowLazyLoadProps[] = [
  {
    header: 'It might take while',
    Paragraph:
      'You can view the volume chart while you wait for the data to load. We’ll let you know when it’s done.',
  },
];

export const cardText = [
  {
    title: 'Create New Scenario',
    description:
      'To analyze price and promo change impacts, set and save your category, market and time periods ',
  },
  {
    title: 'View Base Plans',
    description:
      'Whether you have a team of 2 or 200, our shared team inboxes keep everyone on the same page and in the loop.',
  },
  {
    title: 'Learn More About Scenario Planner',
    description:
      'Follow the link below for metric definitions, FAQs, and tutorials',
  },
];
